import { ForensicsFilterValues } from '@hakimo-ui/hakimo/types';
import { FilterPanel } from '@hakimo-ui/hakimo/ui-filters';
import { Button, HakimoSpinner } from '@hakimo-ui/shared/ui-base';
import { FunnelIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { useState } from 'react';

const forensicsFilterConfigs = [
  {
    type: 'location',
    defaultValue: {
      values: [],
      negative: false,
    },
  },
  {
    type: 'camera',
    defaultValue: {
      values: [],
      negative: false,
    },
  },
  {
    type: 'dateTime',
    defaultValue: { values: [] },
  },
];

export const defaultForensicsFilterValues: ForensicsFilterValues = {
  location: { values: [], negative: false },
  camera: { values: [], negative: false },
  dateTime: {
    startTime: '',
    endTime: '',
  },
};

interface Props {
  filterValues: ForensicsFilterValues;
  setFilterValues: (filters: ForensicsFilterValues) => void;
  isLoading?: boolean;
}

export const ForensicsFilter: React.FC<Props> = ({
  filterValues,
  setFilterValues,
  isLoading,
}) => {
  const [openFilterPanel, setOpenFilterPanel] = useState(false);

  const isNotDefaultForensicsFilter = (
    filters: Partial<ForensicsFilterValues>
  ): boolean => {
    return !!(
      (filters.location && filters.location.values.length > 0) ||
      (filters.camera && filters.camera.values.length > 0) ||
      (filters.dateTime &&
        (filters.dateTime.startTime || filters.dateTime.endTime))
    );
  };

  const onApplyFilters = (values: ForensicsFilterValues) => {
    setFilterValues(values);
    setOpenFilterPanel(false);
  };

  return (
    <div className="flex items-center justify-end gap-2 px-[15%] py-2">
      {isLoading && <HakimoSpinner />}

      <Button
        variant="icon"
        onClick={() => setOpenFilterPanel(true)}
        badge={isNotDefaultForensicsFilter(filterValues)}
        className={clsx(
          'rounded-xl border p-2 transition-all duration-200 hover:scale-105',
          isNotDefaultForensicsFilter(filterValues)
            ? 'border-primary-600/50 bg-primary-600/10 text-primary-600 hover:border-primary-600 dark:text-primary-400 dark:border-primary-400/50 dark:bg-primary-400/10 dark:hover:border-primary-400 dark:hover:bg-primary-400/20 hover:bg-primary-600/20 shadow-md'
            : 'border-onlight-line-2 bg-onlight-bg-1 text-onlight-text-2 hover:border-onlight-line-3 hover:bg-onlight-bg-2 dark:border-ondark-line-2 dark:bg-ondark-bg-2 dark:text-ondark-text-2 dark:hover:bg-ondark-bg-3'
        )}
      >
        <FunnelIcon className="h-5 w-5" />
      </Button>

      <FilterPanel
        title="Forensic Filters"
        open={openFilterPanel}
        filterConfigs={forensicsFilterConfigs as any}
        initialFilterValues={filterValues as any}
        trackingEventNameApply="apply_forensics_filters"
        trackingEventNameReset="reset_forensics_filters"
        onClose={() => setOpenFilterPanel(false)}
        onApply={onApplyFilters as any}
        enableNegativeFilters={true}
      />
    </div>
  );
};

export default ForensicsFilter;
